'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getPurchases(params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `purchases${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getPurchase(id) {
    const data = {
      method: 'get',
      url: 'purchase/' + id,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async getPurchaseDetails(id, params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)

    const data = {
      method: 'get',
      url: `purchase/${id}/details${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
    return {data: [], total: 0}
  },
  async createPurchaseDetails(json) {
    const data = {
      method: 'post',
      url: 'purchase-details',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Purchase product added', 2000)
      return true;
    }
  },
  async updatePurchaseDetails(json, id) {
    const data = {
      method: 'put',
      url: 'purchase-details/' + id,
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Purchase product updated', 2000)
      return true;
    }
  },
  async deletePurchaseDetails(id) {
    const data = {
      method: 'delete',
      url: 'purchase-details/' + id
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Purchase product deleted', 2000)
      return true;
    }
  },
  async changePurchaseStatus(body, id) {
    const data = {
      method: 'patch',
      url: 'purchase-status/' + id,
      body: body,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Purchase submitted successfully')
      window.location.reload();
    }
  },
  async addSupplierInvoice(json) {
    const data = {
      method: 'post',
      url: 'purchase-supplier-invoice',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Supplier invoice added successfully')
      return true;
    }
  },
}
